const DEFAUL_CLIENT_MATRIX = {
  customer: null,
  authorizationGNP: false,
  id: null,
  needAuthAfter: false,
  needAuthBefore: false,
  repairWithoutAuthorization: false
}

const DEFAULT_SINISTER = () => ({
  id: null,
  slug: null,
  customerCodename: null,
  clientMatrix: DEFAUL_CLIENT_MATRIX,
  affecteds: []
})
const DEFAULT_QUOTATION = () => ({
  agreedAmount: null,
  concepts: [],
  damagePayment: false,
  id: 0,
  isActive: true,
  isAuthorized: false,
  isClosed: false,
  isRejected: false,
  pdfFile: null,
  price: 0,
  recalculation: false,
  subprice: null,
  subtotal: 0,
  whoRegistered: null,
  scope: 0,
  comments: null
})
const DEFAULT_COUNTERPROPOSAL = {}
const DEFAULT_BUDGET = {
  concepts: [],
  customerFilesAuthorizations: [],
  authorizationPDRfileSubmissionDate: null
}
const DEFAULT_INVOICE = { uuid: null, complementInvoice: [] }

const DEFAULT_CASUALTY = () => ({
  id: null,
  name: '',
  files: {},
  startRepairDates: [],
  familyAssign: [],
  alternateProcess: {},
  process: {},
  processAbbre: null,
  isTAPayment: false,
  meeting: null,
  scopeMotifs: null,
  processNumber: 0,
  quotation: DEFAULT_QUOTATION(),
  budget: DEFAULT_BUDGET,
  invoice: DEFAULT_INVOICE,
  counterproposal: DEFAULT_COUNTERPROPOSAL
})
const DEFAULT_CATALOGS = {
  supervisors: [],
  followUps: []
}

const FIELDS_PROPS = {
  dense: true,
  clearable: true,
  outlined: true,
  hideDetails: true,
  backgroundColor: 'white',
  menuProps: { offsetY: true }
}

export {
  DEFAULT_SINISTER, DEFAULT_CASUALTY, DEFAULT_CATALOGS, DEFAULT_QUOTATION, DEFAULT_BUDGET, DEFAULT_INVOICE, DEFAULT_COUNTERPROPOSAL, FIELDS_PROPS
}
